import { render, staticRenderFns } from "./EditCategorieMapping.vue?vue&type=template&id=63b2d6c8&scoped=true"
import script from "./EditCategorieMapping.vue?vue&type=script&lang=js"
export * from "./EditCategorieMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2d6c8",
  null
  
)

export default component.exports